import React, { useEffect, useState } from "react";
import { useStyletron } from "baseui";
import { Card, StyledBody } from "baseui/card";

const UsageCard = ({ variableName, usedNumber, limit }) => {
    const [currentNumber, setCurrentNumber] = useState(0);
    const [css, theme] = useStyletron();
  
    useEffect(() => {
        setCurrentNumber(usedNumber); 
    }, [usedNumber]);
  
    const cardStyle = css({
      width: "100%",
      marginTop: "35px",
      textAlign: "center",
      fontSize: "36px", // Adjust font size here if needed
      fontWeight: "bold",
      color: theme.colors.primary,
      fontFamily: "'Roboto', sans-serif", // Google Font
    });
  
    const titleStyle = css({
      fontSize: "18px",
      color: theme.colors.primary,
      marginTop: "15px",
      marginBottom: "10px",
      fontFamily: "'Roboto', sans-serif",
    });
  
    const subtitleStyle = css({
      marginTop: "20px",
      fontSize: "14px",
      color: theme.colors.primary400,
      fontFamily: "'Roboto', sans-serif",
    });
  
    return (
      <Card
        overrides={{
          Root: {
            style: {
              minWidth: "250px",
              marginBottom: "20px",
              marginLeft: "auto",
              marginRight: "auto",
              padding: "30px",
            },
          },
        }}
      >
        <StyledBody>
          <div className={titleStyle}>{variableName}</div>
          <div className={cardStyle}>{currentNumber ?? 0}</div>
          <div className={subtitleStyle}>Available: {limit}</div>
        </StyledBody>
      </Card>
    );
  };

  export default UsageCard;